var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 1.49969V13.3747M8 13.3747L2.375 7.74969M8 13.3747L13.625 7.74969M1.125 15.8747H14.875","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Download.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Download;

Download.default = Download;
